import { useState } from "react";

/**
 * Hook dedicado a gerenciar o estado dos filtros de performance.
 */
export const usePerformanceFilters = () => {
    // Período selecionado (default: mês atual)
    const getDefaultPeriod = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    };

    const [selectedPeriod, setSelectedPeriod] = useState(getDefaultPeriod());
    const [selectedGroup, setSelectedGroup] = useState("all");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    // ─── Gerar opções de período (Anos completos + Mês atual + últimos 11 meses) ───
    const periodOptions = [];
    const now = new Date();
    
    // Opção de Anos completos
    periodOptions.push({ value: String(now.getFullYear()), label: `Ano Completo (${now.getFullYear()})` });
    periodOptions.push({ value: String(now.getFullYear() - 1), label: `Ano Passado (${now.getFullYear() - 1})` });

    for (let i = 0; i <= 11; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
        const label = d.toLocaleDateString("pt-BR", { month: "long", year: "numeric" });
        periodOptions.push({ value, label: label.charAt(0).toUpperCase() + label.slice(1) });
    }

    // Opção Período Customizado
    periodOptions.push({ value: "custom", label: "Período Personalizado" });

    return {
        selectedPeriod,
        setSelectedPeriod,
        selectedGroup,
        setSelectedGroup,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        periodOptions
    };
};
